import { render, staticRenderFns } from "./sign-up-project-detail.html?vue&type=template&id=63a5951e&scoped=true&external"
import script from "./sign-up-project-detail.js?vue&type=script&lang=js&external"
export * from "./sign-up-project-detail.js?vue&type=script&lang=js&external"
import style0 from "./sign-up-project-detail.scss?vue&type=style&index=0&id=63a5951e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5951e",
  null
  
)

export default component.exports